import 'components/activity-indicator/activity-indicator.demo.js'; import 'components/alert/alert.demo.js'; import 'components/autocomplete/autocomplete.demo.js'; import 'components/autogrow/autogrow.demo.js'; import 'components/carousel/carousel.demo.js'; import 'components/form/form.demo.js'; import 'components/modal/modal.demo.js'; import 'components/paging/paging.demo.js'; import 'components/sample/sample.demo.js'; import 'components/tabs/tabs.demo.js';

/****************************************
	Keyboard Shortcuts
*****************************************/
document.addEventListener('keyup', e => {
	if (e.target.matches(':not(input):not(textarea)') && e.which === 192) {
		document.querySelectorAll('article[id], section[id], h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]').forEach(el => {
			el.insertAdjacentHTML('afterbegin', `<a href="#${el.id}" style="background:#fff; position:absolute;">${el.id}</a>`);
		});
	}
});



// WEBPACK FOOTER //
// ./src/demo.js